// DropPin light/dark colour mode. dark = <body class="dark-mode"> which flips
// the surface/text tokens in styles/tokens.css. The theme.js colour object
// routes through those tokens, so most of the UI flips automatically. v0.46.8.
const KEY = 'droppin-color-mode';
export function getStored() {
  try { const v = localStorage.getItem(KEY); if (v === 'light' || v === 'dark') return v; } catch (_) {}
  return null;
}
export function current() {
  return (typeof document !== 'undefined' && document.body.classList.contains('dark-mode')) ? 'dark' : 'light';
}
export function apply(mode) {
  if (typeof document !== 'undefined') document.body.classList.toggle('dark-mode', mode === 'dark');
}
export function setMode(mode) {
  try { localStorage.setItem(KEY, mode); } catch (_) {}
  apply(mode);
}
export function initColorMode() {
  const m = getStored() || 'light';
  apply(m);
  return m;
}
